import {
  ProductsActionsUnion,
  ProductsActionTypes,
  AppendProductsSuccess
} from './products.actions';
import { productsInitialState } from './products.state';

export function productsReducer(state = productsInitialState, action: ProductsActionsUnion) {
  switch (action.type) {
    case ProductsActionTypes.LOAD_PRODUCTS:
      return { ...state, loading: true };
    case ProductsActionTypes.RESET_PRODUCTS:
      return productsInitialState;
    case ProductsActionTypes.LOAD_PRODUCTS_SUCCESS:
      const { response, queryOptions: { limit, offset, filter } } = action.payload;
      return {
        ...state,
        payload: {
          correction: response.correction,
          products: {
            items: response.products.items,
            totalCount: response.products.totalCount
          },
          metaData: response.metaData
        },
        loading: false,
        error: null,
        currentFilter: filter,
        currentOffset: offset,
        currentLimit: limit
      };
    case ProductsActionTypes.APPEND_PRODUCTS_SUCCESS:
      return appendProductSuccess(state, action);
    case ProductsActionTypes.APPEND_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case ProductsActionTypes.LOAD_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        payload: {
          correction: '',
          products: {
            items: [],
            totalCount: 0
          },
          metaData: { hasFood: false }
        },
        currentFilter: {},
        currentOffset: 0,
        currentLimit: 0
      };
    default:
      return state;
  }
}

function appendProductSuccess(state, action: AppendProductsSuccess) {
  const curItems: any[] = state.payload.products.items;
  const newItems: any[] = action.payload.products.items;
  return {
    ...state,
    payload: {
      ...state.payload,
      products: {
        items: [
          ...curItems,
          ...newItems
        ],
        totalCount: state.payload.products.totalCount
      },
    },
    loading: false,
    error: null,
    currentLimit: curItems.length + newItems.length
  };
}
